import { StyleSheet, View } from 'react-native';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

export interface PaymentScheduleTimelineItem {
  id: string;
  label: string;
}

interface PaymentScheduleTimelineProps {
  items: PaymentScheduleTimelineItem[];
  disclosureText?: string;
}

const PaymentScheduleTimeline = ({
  items,
  disclosureText,
}: PaymentScheduleTimelineProps) => {
  return (
    <>
      <View style={styles.scheduleList}>
        {items.map((item, index) => {
          const hasConnector = index < items.length - 1;

          return (
            <View key={item.id} style={styles.scheduleItem}>
              <View style={styles.timelineIndicator}>
                <View style={styles.timelineDot} />
                {hasConnector ? (
                  <View
                    testID="payment-schedule-timeline-connector"
                    style={styles.timelineLine}
                  />
                ) : null}
              </View>
              <BodySmText style={styles.scheduleText} numberOfLines={0}>
                {item.label}
              </BodySmText>
            </View>
          );
        })}
      </View>
      {disclosureText ? (
        <BodyXSText numberOfLines={0} style={styles.disclosureText}>
          {disclosureText}
        </BodyXSText>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  disclosureText: {
    paddingHorizontal: theme.spacing.m,
    paddingBottom: theme.spacing.m,
  },
  scheduleItem: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    minHeight: 36,
  },
  scheduleList: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
  scheduleText: {
    marginLeft: theme.spacing.s,
    marginTop: -3,
    paddingTop: 0,
  },
  timelineDot: {
    borderColor: theme.color.text.tertiary,
    borderRadius: '50%',
    borderWidth: 1,
    height: 14,
    width: 14,
  },
  timelineIndicator: {
    alignItems: 'center',
    height: '100%',
    width: 24,
  },
  timelineLine: {
    borderColor: theme.color.text.tertiary,
    borderStyle: 'dashed',
    borderWidth: 1,
    flex: 1,
  },
});

export default PaymentScheduleTimeline;
